import React, { useMemo, useState, useContext } from 'react'
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { KPI } from 'src/mtska-frontend-app-component';
import { useSettingsContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'cars/car';

const mergeKpiFilters = (baseFilters, extraItems = []) => ({
    items: [...(baseFilters?.items ?? []), ...extraItems],
});

const FleetManagerCarKPI = ({ filters, setFilters, userCapabilities }) => {
    const { t } = useTranslation();
    const { addFilter } = useSettingsContext(dataProviderName);

    return useMemo(() => <>
        <Box className="mtska-chart-wrapper">
            {
                userCapabilities && userCapabilities['auth/role.is_superuser'] && (
                    <KPI
                        title="Vehicles"
                        icon="faCars"
                        dataProviderName={'statisticsviews/item/count/cars/car'}
                        className="superuserData"
                        filters={filters}
                    />
                )
            }
            <KPI
                title="running"
                icon="faCar"
                dataProviderName={'statisticsviews/running/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: () => { addFilter("status", "running", "equals") }
                }}
                filters={mergeKpiFilters(filters, [{
                    field: "status",
                    operator: "equals",
                    value: "running"
                }])}
            />
            <KPI
                title="available"
                icon="faShop"
                dataProviderName={'statisticsviews/available/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: () => { addFilter("status", "available", "equals") }
                }}
                filters={mergeKpiFilters(filters, [{
                    field: "status",
                    operator: "equals",
                    value: "available"
                }])}
            />
            <KPI
                title="in_order"
                icon="faCartShopping"
                dataProviderName={'statisticsviews/order/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: () => { addFilter("status", "in_order", "equals") }
                }}
                filters={mergeKpiFilters(filters, [{
                    field: "status",
                    operator: "equals",
                    value: "in_order"
                }])}
            />
            <KPI
                title="in_offer"
                icon="faHandshake"
                dataProviderName={'statisticsviews/offer/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: () => { addFilter("status", "in_offer", "equals") }
                }}
                filters={mergeKpiFilters(filters, [{
                    field: "status",
                    operator: "equals",
                    value: "in_offer"
                }])}
            />
            <KPI
                title="in_configuration"
                icon="faPencil"
                dataProviderName={'statisticsviews/configuration/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: () => { addFilter("status", "in_configuration", "equals") }
                }}
                filters={mergeKpiFilters(filters, [{
                    field: "status",
                    operator: "equals",
                    value: "in_configuration"
                }])}
            />
            <KPI
                title="closed"
                icon="faFolder"
                dataProviderName={'statisticsviews/closed/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: () => { addFilter("status", "closed", "equals") }
                }}
                filters={mergeKpiFilters(filters, [{
                    field: "status",
                    operator: "equals",
                    value: "closed"
                }])}
            />
            <KPI
                title="canceled"
                icon="faFolder"
                dataProviderName={'statisticsviews/closed/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: () => { addFilter("status", "canceled", "equals") }
                }}
                filters={mergeKpiFilters(filters, [{
                    field: "status",
                    operator: "equals",
                    value: "canceled"
                }])}
            />
        </Box>
    </>, [filters])

}

export default FleetManagerCarKPI;


